import type { Language } from './siteContent'

export const routeFor = (language: Language, path = '') => {
  if (language === 'en') return path ? `/en/${path}` : '/en'
  return path ? `/${path}` : '/'
}

export const alternateLanguagePath = (pathname: string, language: Language) => {
  if (language === 'en') {
    const greekPath = pathname.replace(/^\/en(?=\/|$)/, '')
    return greekPath || '/'
  }
  return pathname === '/' ? '/en' : `/en${pathname}`
}
